"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _themeProvider = require("@mmc/theme-provider");

var _checkbox = _interopRequireDefault(require("./checkbox"));

var _input = _interopRequireDefault(require("./input"));

var _excluded = ["type"];

var InputResolver = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var type = _ref.type,
      props = (0, _objectWithoutPropertiesLoose2["default"])(_ref, _excluded);
  var theme = (0, _themeProvider.useTheme)();

  if (type === 'checkbox') {
    return /*#__PURE__*/_react["default"].createElement(_checkbox["default"], (0, _extends2["default"])({
      ref: ref,
      theme: theme
    }, props));
  }

  return /*#__PURE__*/_react["default"].createElement(_input["default"], (0, _extends2["default"])({
    ref: ref,
    theme: theme,
    type: type
  }, props));
});

InputResolver.defaultProps = {
  type: 'text'
};
var _default = InputResolver;
exports["default"] = _default;